<div class="fx-fill fx-layout-col">
  <div class="sheet-header">
    <div class="fx-layout-row fx-justify-start fx-align-baseline">
      <div class="sheet-title fx-flex-85-percent">
        <span>{{ entity?.toString() }}</span>
      </div>
      <div class="fx-flex-48">
        <div class="btn-container">
          <button (click)="closeSidePanel()" [disableRipple]="true"
            class="fx-layout-col fx-justify-center fx-align-center"
            id="close-sheet-button" mat-icon-button>
            <mat-icon fontSet="mdi" fontIcon="mdi-close" class="sm"></mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="fx-layout-row">
      <restricted-icon-button
        (click)="downloadDocument()"
        icon="mdi-download"
        iconClass="sm"
        [matTooltip]="'BUTTON.DOWNLOAD_DOCUMENT' | translate"
        [disabled]="!downloadEnabled"
        [permissions]="[Permission.EXPORT_DOCUMENT]">
      </restricted-icon-button>

      <restricted-icon-button
        (click)="deleteDocument()"
        icon="mdi-delete"
        iconClass="sm"
        [matTooltip]="'BUTTON.DELETE' | translate"
        [preconditions]="accessManager.hasAllNeededPermissions(permissionsForDeletion)">
      </restricted-icon-button>

      @if (displayAssetSheetLink) {
        <span class="fx-flex"></span>
      }

      @if (displayAssetSheetLink && entity?.relatedAssets?.length === 1) {
        <div class="sheet-link">
          <span (click)="navigateToAssetSheet()"> {{ 'BUTTON.SHOW_ASSET_SHEET' | translate }} </span>
        </div>
      }
    </div>
  </div>
  <div class="sidebar-sheet fx-flex-grow" cdk-scrollable>
    <div class="page-sidebar">
      <div class="form-container">
        @if (entity) {
          <form-builder
            [formId]="formId"
            [displayHeader]="false"
            [eventsOrigin]="eventsOrigin"
            [permissionsForEdition]="permissionsForEdition">
          </form-builder>
        }
      </div>
    </div>
  </div>
</div>
